<template>
    <layout-empty>
        <div class="page-error">
            <h1>Tvåfaktorsautentisering krävs</h1>
            <p>Denna sida kräver att du aktiverar & loggar in med tvåfaktorsautentisering</p>
            <a
                href="https://myaccount.kvantbit.net/"
                class="sp-button-filled"
            >Aktivera här</a>
        </div>
    </layout-empty>
</template>

<script>
    export default {

    };
</script>


<style lang="scss" scoped>
    @import "@/assets/scss/variables.scss";

    .page-error {
        flex: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        h1 {
            color: $colorAccent;
            font-size: 1.2rem;
        }

        p {
            color: $colorDark1;
        }

        .sp-button-filled {
            margin: 10px 0 0 0;
        }
    }
</style>
